// extracted by mini-css-extract-plugin
module.exports = {"NavLink":"SideNav_NavLink__2NbVy"};